import { useAbilitiesState } from "@/shared/stores/app-state";
import { AbilityType } from "@/shared/types/abilities-types";

export const useHasAbilities = (abilityName: AbilityType) => {
	const { hasAbility } = useAbilitiesState();

	return hasAbility(abilityName);
};
